import { FabMenu } from '@e3dc-react/shell/Elements/FabMenu'
import React from 'react'
import { resetStoreHistoryData } from '../../../system-data-handler/state/store'
import useModals from 'src/Hooks/useModals'
import ReactGridLayout from 'react-grid-layout'
import { A0dashboard, J2Add, J2Update } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { CustomLayout, LoadingState } from '../../shared/utils/chartModel'
import { isUndefined } from 'lodash'
import { ChartSettings } from 'src/Libs/chart-kit'

/* TODO: Wait for implementation to re-organize charts and then show the button again */
const ORDERING_CHARTS_IS_IMPLEMENTED = false

interface Props {
  storageId?: string
  layouts: ReactGridLayout.Layouts
  installationId?: number
  chartLoadingIsCompleted: boolean
  loadingState: LoadingState
  saveCharts: (settings: ChartSettings) => void
  defaultAndCustomCharts: CustomLayout[]
  visible?: boolean
}

/**
 * Floating action button with chart actions used on the dashboard to add the possiblity
 * of adding new charts, updating the chart layout and resetting the redux store so that
 * the history values are redownloaded.
 */
const FabActionsButton: React.FC<Props> = ({
  storageId,
  layouts,
  installationId,
  chartLoadingIsCompleted,
  loadingState,
  saveCharts,
  defaultAndCustomCharts,
  visible = true,
}) => {
  const { openSystemChartEditor, openChartLayoutEditor } = useModals()
  const { t } = useCustomTranslation()

  const reloadData = (): void => {
    if (storageId) {
      resetStoreHistoryData(storageId)
    }
  }

  const fabActions = []

  if (installationId && chartLoadingIsCompleted) {
    fabActions.push({
      icon: <J2Add />,
      name: t('dashboard.addChart'),
      callback: () =>
        openSystemChartEditor({
          handleSaveChart: saveCharts,
          serialNumber: storageId,
          views: { day: 'line', week: 'line', month: 'bar', year: 'bar', hour: 'bar' },
          loadingState,
        }),
      id: 'add-chart',
    })
  }

  if (ORDERING_CHARTS_IS_IMPLEMENTED) {
    fabActions.push({
      icon: <A0dashboard />,
      name: t('dashboard.editLayout'),
      callback: () => openChartLayoutEditor({ defaultAndCustomCharts, customLayout: layouts }),
      id: 'edit-layout',
    })
  }

  fabActions.push({
    icon: <J2Update />,
    name: t('dashboard.reloadData'),
    callback: () => reloadData(),
    id: 'reload-data',
    disabled: isUndefined(storageId),
  })

  return <FabMenu visible={visible} actions={fabActions} ariaLabel={'open menu'} data-qa={'system-charts-menu'} />
}

export default FabActionsButton
